import React from 'react'
import { InputContainer } from '../../../common/components/form/form.module';
import GoogleMapSearch from '../../../common/components/google-map-search';

export default function ModalLeadComponent({ selectedEstimateItem, dropLocations, pickupLocations, setDropLocations, setPickupLocations,
    handleInnerFormChange }: any) {


    return (

        <div className=" w-full p-2 bg-white shadow-md rounded-md">
            <h1 className="text-xl font-bold mb-4 text-center">Edit Details</h1>
            <div className=' grid md:grid-cols-2 lg:grid-cols-3 gap-4'>

                <div className="">
                    <div className='font-semibold line-clamp-2 mb-2 text-slate-800'>Pickup Address <span className="text-red-500">*</span></div>
                    <GoogleMapSearch
                        setLocation={setPickupLocations}
                        location={pickupLocations}
                        placeholder="Search Address" />
                </div>
                <InputContainer
                    isRequired
                    label="Name"
                    name="Name"
                    onValueChange={(event: any) => {
                        handleInnerFormChange(
                            event.target.value,
                            'Name'

                        )
                    }}
                    type="text"
                    value={selectedEstimateItem?.Name}
                />
                <InputContainer
                    isRequired
                    label="PhoneNumber"
                    name="PhoneNumber"
                    onValueChange={(event: any) => {
                        handleInnerFormChange(
                            event.target.value,
                            'PhoneNumber'

                        )

                    }}
                    type="phonenumber"
                    value={selectedEstimateItem?.PhoneNumber}
                />
                <div className=" ">
                    <div className='font-semibold line-clamp-2 mb-2 text-slate-800'>Drop Address <span className="text-red-500">*</span></div>
                    <GoogleMapSearch
                        setLocation={setDropLocations}
                        location={dropLocations}
                        placeholder="Search Address" />
                </div>

                <InputContainer
                    isRequired
                    label="Name"
                    name="Name"
                    onValueChange={(event: any) => {
                        handleInnerFormChange(
                            event.target.value,
                            'DropName'

                        )
                    }}
                    type="text"
                    value={selectedEstimateItem?.DropName}
                />
                <InputContainer
                    isRequired
                    label="PhoneNumber"
                    name="PhoneNumber"
                    onValueChange={(event: any) => {
                        handleInnerFormChange(
                            event.target.value,
                            'DropPhoneNumber'

                        )

                    }}
                    type="phonenumber"
                    value={selectedEstimateItem?.DropPhoneNumber}
                />


            </div>


        </div>

    )
}